import axios from "axios";
import { MAPBOX_TOKEN } from "../constants/cons";
import { URL_MAPBOX_GEOCODING, URL_MAPBOX_DIRECTIONS } from "../constants/url";

const geoFetch = axios.create({
  baseURL: URL_MAPBOX_GEOCODING,
  params: {
    country: "mx",
    language: "es",
    access_token: MAPBOX_TOKEN,
  },
});

export const directionsFetch = axios.create({
  baseURL: URL_MAPBOX_DIRECTIONS,
  params: {
    geometries: "geojson",
    access_token: MAPBOX_TOKEN,
  },
});

export default geoFetch;
